import { normalizeTag, normalizeTags, tagKey } from "./tags.js";
const rewrite = (tags, fromKey, to) => normalizeTags(tags.map((t) => (tagKey(t) === fromKey ? to : t)));
const sameTags = (a, b) => a.length === b.length && a.every((t, i) => t === b[i]);
/**
 * Plan a rename of `from` to `to` across a list's items, todos and notes.
 *
 * Returns an empty plan when the rename is a no-op: nothing carries `from`, or `to`
 * normalizes away, or `to` is `from` in the same casing. Renaming to a *different
 * casing* of the same tag is a real change (that is the "clothing" → "Clothing" case)
 * and is planned normally.
 */
export const planTagRename = (contents, from, to) => {
    const target = normalizeTag(to);
    const empty = { from, to, merges: false, entries: [] };
    if (target === null)
        return empty;
    const fromKey = tagKey(from);
    const targetKey = tagKey(target);
    const entries = [];
    let merges = false;
    const visit = (collection, id, tags) => {
        if (tags === undefined || tags.length === 0)
            return;
        const carriesFrom = tags.some((t) => tagKey(t) === fromKey);
        // A row that already has the target and not the source is untouched, but its
        // existence is what makes this rename a merge.
        if (tags.some((t) => tagKey(t) === targetKey) && targetKey !== fromKey)
            merges = true;
        if (!carriesFrom)
            return;
        const next = rewrite(tags, fromKey, target);
        if (sameTags(next, tags))
            return;
        entries.push({
            collection,
            id,
            tags: next.length === 0 ? null : next,
            previousTags: [...tags],
        });
    };
    for (const i of contents.items)
        visit("items", i.id, i.tags);
    for (const t of contents.todos)
        visit("todos", t.id, t.tags);
    for (const n of contents.notes)
        visit("notes", n.id, n.tags);
    return { from, to: target, merges, entries };
};
/** The inverse plan: apply it to put every touched row back exactly as it was. */
export const invertTagRename = (plan) => ({
    from: plan.to,
    to: plan.from,
    merges: false,
    entries: plan.entries.map((e) => ({
        collection: e.collection,
        id: e.id,
        tags: e.previousTags,
        previousTags: e.tags,
    })),
});
//# sourceMappingURL=renameTag.js.map